/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Clear: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 3C9.44772 3 9 3.44772 9 4C9 4.55228 9.44772 5 10 5L14 5C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3L10 3ZM5 8H5.05965L5.68637 18.1843C5.78374 19.7666 7.09541 21 8.68071 21H15.3193C16.9046 21 18.2163 19.7666 18.3136 18.1843L18.9404 8H19C19.5523 8 20 7.55228 20 7C20 6.44771 19.5523 6 19 6H18.0072H17.9909L6.00909 6H5.9928H5C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8ZM7.68259 18.0614L7.06343 8L16.9366 8L16.3174 18.0614C16.2849 18.5889 15.8477 19 15.3193 19H8.68071C8.15227 19 7.71505 18.5889 7.68259 18.0614Z'
      fill='currentColor'
    />
  </React.Fragment>
)
